import { createSelector } from "reselect";

const drawerCollapsed = (state) => state.drawerCollapsed;

export const getCollapsed = createSelector(
  [drawerCollapsed],
  (collapsed) => collapsed
);

const viewType = (state) => {
  // currentView is an object, extract viewType from it
  return state.designChapter.currentView?.viewType;
};

export const getViewType = createSelector([viewType], (viewType) => viewType);

const title = (state) => {
  // currentView contains the view data directly
  return state.designChapter.currentView?.title || "";
};

export const getTitle = createSelector([title], (title) => title);

const description = (state) => {
  // currentView contains the view data directly
  return state.designChapter.currentView?.description || [];
};

export const getDescription = createSelector(
  [description],
  (description) => description
);

const slideTree = (state) => {
  // currentView contains the view data directly
  return state.designChapter.currentView?.slideTree || [];
};

export const getSlideTree = createSelector(
  [slideTree],
  (slideTree) => slideTree
);

const totalNodeComponents = (state) => {
  // currentView contains the view data directly
  return state.designChapter.currentView?.totalNodeComponents || 0;
};
const correctNodeComponents = (state) => {
  // currentView contains the view data directly
  return state.designChapter.currentView?.correctNodeComponents || 0;
};

export const getHintVisibility = createSelector(
  [totalNodeComponents, correctNodeComponents],
  (totalNodeComponents, correctNodeComponents) => {
    if (totalNodeComponents === correctNodeComponents) return false;
    else return true;
  }
);

const currentChapter = (state) => state.currentChapter;

export const getIsDesignChapter = createSelector(
  [currentChapter],
  (currentChapter) => currentChapter === undefined
);

const designChapter = (state) => state.designChapter;

export const getAvailableViewTypes = createSelector(
  [designChapter],
  (designChapter) => {
    if (!designChapter) {
      return ['STEPS', 'TECHNIQUES']; // Fallback to both for safety
    }

    // View types are stored as top-level keys in designChapter (not under allViews)
    const allKeys = Object.keys(designChapter);
    // Filter to only include STEPS and TECHNIQUES view types
    const filteredKeys = allKeys.filter(key => ['STEPS', 'TECHNIQUES'].includes(key));

    // Ensure we always return at least one valid view type
    return filteredKeys.length > 0 ? filteredKeys : ['STEPS', 'TECHNIQUES'];
  }
);

export const getViewDisplayNames = createSelector(
  [designChapter],
  (designChapter) => {
    if (!designChapter) {
      return { STEPS: 'Steps', TECHNIQUES: 'Techniques' }; // Default display names
    }

    const displayNames = {};
    Object.keys(designChapter).forEach(viewType => {
      if (['STEPS', 'TECHNIQUES'].includes(viewType)) {
        // View data is stored directly as top-level keys
        displayNames[viewType] = designChapter[viewType].displayName || viewType;
      }
    });

    // Fallback display names
    return {
      STEPS: 'Steps',
      TECHNIQUES: 'Techniques',
      ...displayNames
    };
  }
);
